var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "25px",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0ABC76DB-BB76-455D-97EC-B6B534EE80B4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BackOffice",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home_Chat-Copy",
    transform: "translate(-971.000000, -328.000000)",
    fill: "#E71037",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(971.000000, 328.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2017856,22.1516666 L17.3938426,16.1316491 C18.8871668,14.3624871 19.705368,12.1365193 19.705368,9.81919039 C19.705368,4.4049742 15.2853683,0 9.85268398,0 C4.41999971,0 0,4.4049742 0,9.81919039 C0,15.2334066 4.41999971,19.6383808 9.85268398,19.6383808 C11.8921896,19.6383808 13.8357386,19.0253218 15.4974151,17.8615342 L21.3494811,23.9272324 C21.5940846,24.1803967 21.9230786,24.32 22.2756333,24.32 C22.6093395,24.32 22.9259105,24.1932044 23.1662303,23.9626669 C23.6768564,23.4729881 23.6931347,22.6609837 23.2017856,22.1516666 Z M9.85268398,2.56152793 C13.8682953,2.56152793 17.1351026,5.81722993 17.1351026,9.81919039 C17.1351026,13.8211509 13.8682953,17.0768529 9.85268398,17.0768529 C5.83707269,17.0768529 2.57026539,13.8211509 2.57026539,9.81919039 C2.57026539,5.81722993 5.83707269,2.56152793 9.85268398,2.56152793 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2cc348ee.svg";
export { ForwardRef as ReactComponent };